import React from 'react';
import PropTypes from 'prop-types';
import { PieChart as Chart, Pie, ResponsiveContainer, Cell } from 'recharts';
import { getColor } from '../helpers';

const PieChart = ({ data }) => (
  <ResponsiveContainer>
    <Chart>
      <Pie data={data} label={false} labelLine={false} dataKey="value" isAnimationActive={false} outerRadius="100%">
        {data.map((item, index) => (
          <Cell fill={getColor(index)} key={item.id} />
        ))}
      </Pie>
    </Chart>
  </ResponsiveContainer>
);

PieChart.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
};

PieChart.defaultProps = {
  colors: {},
  data: {},
};

export default PieChart;
